// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EWxVp","rootMobile":"styles_rootMobile__qPA2J"};